import {appFetch, AppFetchResponse} from "../utils/appFetch";

const getCheckoutRecoverableVsRecovered = (days: number, selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `statistics/checkouts-recoverable-vs-recovered/${days}?domain=${selectedDomain}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        isEncrypted: true,
    });
}

export default getCheckoutRecoverableVsRecovered;